import { Stack } from '@zet/design-system/layout'
import { B2, H5 } from '@zet/design-system/typography'
import { i18n } from '@zet/localization'

type BankPageSuccessMessageType = {
  type: string
}

export const BankPageSuccessMessage = ({
  type,
}: BankPageSuccessMessageType) => {
  return (
    <Stack>
      <Stack className="mt-[28] w-72 items-center">
        <H5 family="graphie">
          {type === 'Paytm'
            ? i18n.t('paytmStatusSuccessTitle')
            : i18n.t('bankStatusSuccessTitle')}
        </H5>
        <B2 className="text-grays-80 text-center">
          {type === 'Paytm'
            ? i18n.t('paytmStatusSuccessMessage')
            : i18n.t('bankStatusSuccessMessage')}
        </B2>
      </Stack>
    </Stack>
  )
}
